export const initialState = {
  unitList: [],
  taskList: [],
  isUnitsLoaded: false,
  unitMessage: "",
};
